export default "__VITE_ASSET__CsG3BV_7__"